module.exports = __webpack_public_path__ + "img/xlsx.a3b326d4.png";